module.exports = __webpack_public_path__ + "img/rs.d00d37d2.svg";